import { Component } from '@angular/core';
import { StatusService } from '../../services/authentication/status.service';

interface Toast {
  show: boolean;
  showType: string;
  message: string;
}

/**
 * Componente para exibir notificações em forma de toast. (ids alert)
 */
@Component({
  selector: 'app-alert-toast-notification',
  templateUrl: './alert-toast-notification.component.html',
  styleUrls: ['./alert-toast-notification.component.scss'],
})
export class AlertToastNotificationComponent {
  /** Lista de toasts a serem exibidos */
  toasts: Toast[] = [];

  constructor(private statusService: StatusService) {
    // Inscreve-se para receber notificações de toast
    this.statusService.toastState.subscribe(toast => {
      this.showToast(toast.showType, toast.message);

      if (toast.showType === 'clear') {
        this.toasts = [];
      }
    });
  }

  /**
   * Exibe um novo toast com o tipo e mensagem especificados.
   * @param showType Tipo do toast a ser exibido, sera usado no atributo
   * variant dos ids-alert (pode ser information, error ou success)
   * @param message Mensagem a ser exibida no toast
   */
  showToast(showType: string, message: string) {
    const toast: Toast = {
      show: true,
      showType: showType,
      message: message,
    };

    // Adiciona o novo toast à lista
    this.toasts.push(toast);

    // Fecha o toast após 5 segundos
    setTimeout(() => {
      this.closeToast(toast);
    }, 5000);
  }

  /**
   * Fecha o toast especificado.
   * @param toast Toast a ser fechado
   */
  closeToast(toast: Toast) {
    toast.show = false;
    // Remove o toast da lista após 300ms
    setTimeout(() => {
      const index = this.toasts.indexOf(toast);
      this.toasts.splice(index, 1);
    }, 300);
  }
}
